module.exports = __webpack_public_path__ + "static/img/5.5b7baa05.jpg";